import { useGlobalContext } from "../data/GlobalContext"

export default function OTPNotice() {
  const { playerDetails } = useGlobalContext()

  return (
    <p className="payment-email-content">
      OTP will be sent to{" "}
      <span className="payment-email">{playerDetails.email}</span>. Need to
      change your email? Update it on profile{" "}
      <a href="/profile#accounts">page</a>.
    </p>
  )
}
